import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavbarToggler,
  NavItem,
  NavLink,
  Container,
  Collapse,
} from "reactstrap";

import ScrollspyNav from "./Scrollspy";
import logo from "../../assets/images/logo-circular-light-200x200.webp";

class NavbarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMenu: false,
      isMobile: window.innerWidth <= 991,
    };
    this.toggle = this.toggle.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth <= 991,
    });
  };

  toggle = () => {
    this.setState({ isOpenMenu: !this.state.isOpenMenu });
  };

  handleMenuClick = (e) => {
    e.preventDefault();
    this.setState({ isOpenMenu: false });

    const href = e.currentTarget.getAttribute("href") || "";
    const targetId = href.startsWith("#") ? href.substring(1) : "";
    const targetElement = targetId ? document.getElementById(targetId) : null;

    if (targetElement) {
      const navbarHeight = document.querySelector(".navbar-custom")?.offsetHeight || 0;
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  render() {
    const { isMobile } = this.state;
    const targetId = this.props.navItems.map((item) => item.idnm);

    return (
      <Navbar
        expand="lg"
        fixed={this.props.top === true ? "top" : ""}
        className={`${this.props.navClass} navbar-custom sticky sticky-dark px-4`}
        id="navbar"
      >
        <Container className="d-flex align-items-center position-relative">
          <a
            href="#home"
            className="navbar-brand-logo"
            onClick={this.handleMenuClick}
          >
            <img
              src={logo}
              alt="Logo Seguridad al Límite"
              width="44"
              height="44"
              loading="eager"
            />
            <span className="navbar-brand-name d-none d-md-inline">
              Seguridad al Límite
            </span>
          </a>

          <NavbarToggler
            onClick={this.toggle}
            className="border-0 ms-auto d-lg-none"
            aria-label={this.state.isOpenMenu ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
            aria-expanded={this.state.isOpenMenu}
          >
            <i
              className={`mdi ${this.state.isOpenMenu ? "mdi-close" : "mdi-menu"} text-white`}
              aria-hidden="true"
            ></i>
          </NavbarToggler>

          <Collapse
            isOpen={this.state.isOpenMenu}
            navbar
            className="mobile-menu"
          >
            <ScrollspyNav
              scrollTargetIds={targetId}
              scrollDuration="600"
              headerBackground="true"
              activeNavClass="active"
              className="navbar-collapse"
            >
              <Nav
                className={`${isMobile ? "flex-column" : ""} mx-auto align-items-center`}
                navbar
              >
                {this.props.navItems.map((item) => (
                  <NavItem
                    key={item.id}
                    className={isMobile ? "w-100 text-center mb-2" : ""}
                  >
                    <NavLink
                      href={"#" + item.idnm}
                      onClick={this.handleMenuClick}
                    >
                      {item.navheading}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </ScrollspyNav>

            <div
              className={`navbar-cta ${isMobile ? "navbar-cta--mobile" : ""} ${
                this.props.showNavCta || isMobile ? "navbar-cta--visible" : ""
              }`}
              aria-hidden={!(this.props.showNavCta || isMobile)}
            >
              <a
                href="https://cursos.seguridadallimite.com/#/student/inscription"
                className={`btn btn-primary amarillo ${isMobile ? "w-100 mb-2" : "me-2"}`}
                tabIndex={this.props.showNavCta || isMobile ? 0 : -1}
              >
                Inscríbete
              </a>
              <a
                href="https://cursos.seguridadallimite.com/#/student/certificate"
                className={`btn btn-primary amarillo ${isMobile ? "w-100" : ""}`}
                tabIndex={this.props.showNavCta || isMobile ? 0 : -1}
              >
                Certificados
              </a>
            </div>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavbarPage;
